import { Link } from "react-router-dom";

import styled, { css } from "styled-components";
import { Button } from "react-bootstrap";

export const baseStyle = css`
  height: 48px;
  border-radius: 8px;
  color: var(--white-color);
  &:hover {
    color: var(--white-color);
  }
  &:focus {
    outline: none;
  }
  &.btn-primary:disabled,
  &.btn-primary.disabled {
    background-color: var(--deactive-color) !important;
    color: var(--white-color) !important;
  }
  &.btn-outline-primary {
    color: var(--blue-color-dark);
    border-radius: 12px;
    &:hover {
      color: var(--white-color);
    }
  }
  &.btn-link {
    color: var(--primary-color);
    font-size: var(--font-size-md);
  }
  @media screen and (max-width: 425px) {
    font-size: var(--font-size-sm);
  }
  font-size: ${({ fontSize }) =>
    fontSize ? `var(--font-size-${fontSize})` : "var(--font-size-lg)"};
  background-color: ${({ disabled }) => disabled && "var(--deactive-color)"};
`;

export const StyledButton = styled(Button)`
  ${baseStyle};
`;

export const StyledLink = styled(Link)`
  ${baseStyle};
  display: flex;
  align-items: center;
`;
